import React from 'react';
import SharedNavbarTop from 'shared_items/NavbarTop';

const NavbarTop = ({ title = 'Identity', onHomeClick, activeTab, onTabChange }) => (
  <SharedNavbarTop
    title={title}
    moduleKey="identity"
    onHomeClick={onHomeClick}
    zIndexClass="z-40"
    settingsActive={activeTab === 'settings'}
    onSettingsClick={() => onTabChange(activeTab === 'settings' ? 'overview' : 'settings')}
  />
);

export default NavbarTop;
